/**
 * Get clean platform ids from array of platform objects or array of platform ids
 * @param {Object[]|string[]} platforms - Array of platform objects that have `id`
 *   field or array of platform ids.
 * @param {string} platforms[].id - Platform ID
 * @returns {string[]} - Array of platform ids with removed temp prefixes.
 */
const getPlatformIds = (platforms) => {
    if (!platforms || platforms.length === 0) return null;

    if (typeof platforms[0] === 'object') {
        platforms = platforms.map((p) => p.id);
    }

    return platforms;
};

export { getPlatformIds };
